const greyColors = {
    black100: '#141414',
    black80: '#1F2020',
    grey100: '#404754',
    grey80: '#677286',
    grey60: '#B3BBC9',
    grey40: '#E0E6E9',
    grey20: '#F3F5F6',
    black: '#000000',
    shadowColor: '#E9EDEF',
};
const defaultFonts = {
    title40: { fontSize: 40, fontWeight: 700, lineHeight: 60 },
    title35: { fontSize: 35, fontWeight: 700, lineHeight: 56 },
    title25: { fontSize: 25, fontWeight: 700, lineHeight: 40 },
    title20: { fontSize: 20, fontWeight: 700, lineHeight: 32 },
    title18: { fontSize: 18, fontWeight: 700, lineHeight: 28 },
    title16: { fontSize: 16, fontWeight: 700, lineHeight: 24 },
    title14: { fontSize: 14, fontWeight: 700, lineHeight: 20 },
    title12: { fontSize: 12, fontWeight: 700, lineHeight: 20 },
    title10: { fontSize: 10, fontWeight: 700, lineHeight: 16 },
    title8: { fontSize: 8, fontWeight: 700, lineHeight: 16 },
    subtitle12: { fontSize: 12, fontWeight: 700, lineHeight: 16 },
    body20: { fontSize: 20, fontWeight: 400, lineHeight: 32 },
    body18: { fontSize: 18, fontWeight: 400, lineHeight: 28 },
    body16: { fontSize: 16, fontWeight: 400, lineHeight: 24 },
    body14: { fontSize: 14, fontWeight: 400, lineHeight: 20 },
    body12: { fontSize: 12, fontWeight: 400, lineHeight: 20 },
    body10: { fontSize: 10, fontWeight: 400, lineHeight: 16 },
    bodyMedium12: { fontSize: 12, fontWeight: 500, lineHeight: 24 },
    bodyBold10: { fontSize: 10, fontWeight: 700, lineHeight: 16 },
};
export const colors = {
    ...greyColors,
    white: '#ffffff',
    green: '#7ed321',
    blue: '#00ABE5',
    red: '#F24949',
    orange: '#F8D064',
    purple: '#6E56E3',
    yellow: '#FEA932',
    lightenBlue: '#E8F5FC',
    lightRed: '#ffcccc',
    lightGreen: '#d4f5b1',
    lightOrange: '#FFF6E0',
    darkBlue: '#172B4D',
    darkRed: '#d63333',
    infoBlue: '#0099FF',
    formGrey: '#ECEBEF',
    selectPicker: {
        pink: '#E675A8',
        purple: '#451BF1',
        yellow: '#FFB83B',
        green: '#00AEAB',
        purpleLight: '#D2CCFF',
        greenDark: '#376338',
        pinkLight: '#FFCCFF',
        orange: '#EB5C26',
        blue: '#41B6E6',
        blueDark: '#2A0D9E',
    },
};
export const fonts = {
    gilroy: 'Gilroy',
    poppins: 'Poppins',
};
export const defaultFontsLibrary = defaultFonts;
// Unité de base de la grille d'espacement, en pixels. Reprend la valeur de
// `gridSize()` d'@atlaskit/theme, que les versions récentes n'exportent plus.
export const gridSize = 8;
